import { createActions, createReducer } from 'reduxsauce'

import ConsultaDiariasService from '../../servicos/ConsultaDiariasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaDiariasInicio: [],
    buscaConsultaDiariasSucesso: ['consultaDiarias'],
    buscaConsultaDiariasErro: ['erro'],
    setSelecionadoConsultaDiariasSucesso: ['selecionado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataSincronizacaoDados: null,
}

// Ação para busca completa
Creators.buscaConsultaDiarias = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaDiariasInicio())
        let serv = new ConsultaDiariasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaDiariasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaDiariasErro(error)))
    }
}

const buscaConsultaDiariasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaDiariasErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaDiariasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.consultaDiarias.resultado, dataSincronizacaoDados: action.consultaDiarias.dataSincronizacaoDados, carregando: false }
}

const setSelecionadoConsultaDiariasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_DIARIAS_INICIO]: buscaConsultaDiariasInicio,
    [Types.BUSCA_CONSULTA_DIARIAS_ERRO]: buscaConsultaDiariasErro,
    [Types.BUSCA_CONSULTA_DIARIAS_SUCESSO]: buscaConsultaDiariasSucesso,
    [Types.SET_SELECIONADO_CONSULTA_DIARIAS_SUCESSO]: setSelecionadoConsultaDiariasSucesso,
})
